<body class="motif-theme-dark">

  
<ng-container
  *ngIf="{ value: authenticationService.subject | async }; let isLoggedIn"
>
  <!-- If logged in -->
   @if(isLoggedIn.value===true) {

  
  <ng-container>
    <div class="contents">
      <app-header
        (changeThemeEvent)="toggleTheme()"
        (toggleMenuEvent)="toggleMenu()"
      ></app-header>
      
      <app-sidebar-nav></app-sidebar-nav>

      <main>
        <router-outlet></router-outlet>
      </main>
      <p style="display: none;"
        (window:beforeunload)="logoutOnClose()"
        (window:unload)="logoutOnClose()"
      ></p>
    </div>
  </ng-container>
}

  <!-- If not logged in -->
  <ng-container *ngIf="isLoggedIn.value === false">
    <router-outlet></router-outlet>
  </ng-container>
  <app-footer></app-footer>
</ng-container>

</body>
